import { makeApiRequest } from 'actions/api';
import RequestService from 'services/RequestService';

export const GET_PROMOTIONS = 'GET_PROMOTIONS';
export const GET_PROMOTIONS_REQUEST = 'GET_PROMOTIONS_REQUEST';
export const GET_PROMOTIONS_RESPONSE = 'GET_PROMOTIONS_RESPONSE';
export const GET_PROMOTIONS_ERROR = 'GET_PROMOTIONS_ERROR';

export const getPromotions = () =>
  makeApiRequest({
    requestType: GET_PROMOTIONS,
    method: RequestService.getPromotions,
  });
